import { AdhesionMode } from './getAdhesionDetails';
import parseArcaResponse from '../parseArcaResponse';

interface UpdateB2CContributionDayResponse {
	success: boolean;
	data?: { contributionDay: number };
}

/**
 * Cambia el día del mes en que se ejecuta la aportación periódica del usuario
 * autenticado. Disponible para B2C SIN empresa (individual o autónomo), y para
 * multi-cuenta pasando `mode` explícito (Fase 4, épica multi-cuenta).
 * El backend dispatcha al campo correcto del jsonb según el tipo de usuario.
 *
 * `userEppConfigId` es el plan CONCRETO (`user_epp_config.id`). `mode` no nombra
 * una fila: con dos planes del mismo tipo el backend responde `PLAN_REQUIRED` en
 * vez de elegir, y hace bien — escribir el día en el plan equivocado significa
 * cobrar todos los meses en el que no era. La vista ya tiene su plan resuelto,
 * así que manda su id. Opcional: sin él, el comportamiento es el de siempre.
 */
const updateB2CContributionDay = async (
	token: string,
	contributionDay: number,
	mode?: AdhesionMode,
	userEppConfigId?: string
): Promise<UpdateB2CContributionDayResponse> => {
	const response = await fetch(
		`${process.env.REACT_APP_BASE_API}/users/b2c-individual-contribution-day`,
		{
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			},
			body: JSON.stringify({
				contributionDay,
				...(mode ? { mode } : {}),
				...(userEppConfigId ? { userEppConfigId } : {})
			})
		}
	);

	return parseArcaResponse<UpdateB2CContributionDayResponse>(response);
};

export default updateB2CContributionDay;
